import superService from "./superService";
import gameConfig from "../configs/gameConfig";
import miniGameService from "./miniGameService";
import {DEEP_NEXT_SPLIT} from "../configs/logConfig";
import O1HD, {modules, services} from "../gameEngine";

export enum PLATFORM_CODE {
    WX = 'wx',
    TT = 'tt',
    HU_WEI = '',
    VIVO = 'vivo',
    OPPO = 'oppo',
    ANDROID = 'app/Android',
    IOS = 'app/iOS',
    KS = 'ks',
    H5 = 'h5',
    H5_4399 = 'h5-4399',
    GAME_BOX_4399 = 'gamebox-4399'
}

export default class ossService extends superService {

    protected className: string = 'oss服务';

    //地址
    private readonly m_htpUrl: string = 'https://oss.tobetopone.com/oss/nxdrs/#.json';
    private readonly m_ossVersion: string = '1.0.0';
    //
    private m_platform: PLATFORM_CODE = PLATFORM_CODE.WX;

    constructor() {
        super();
    }

    getVersion() {
        return this.m_ossVersion;
    }

    getPlatform() {
        return this.m_platform;
    }

    getPlatExplainOfPlatform(platform: PLATFORM_CODE): string {
        switch (platform) {
            case PLATFORM_CODE.ANDROID:
                return '安卓手机';
            case PLATFORM_CODE.H5:
                return 'H5';
            case PLATFORM_CODE.HU_WEI:
                return '华为快游戏';
            case PLATFORM_CODE.IOS:
                return '苹果手机';
            case PLATFORM_CODE.KS:
                return '快手小游戏';
            case PLATFORM_CODE.OPPO:
                return 'OPPO小游戏';
            case PLATFORM_CODE.TT:
                return '抖音小游戏';
            case PLATFORM_CODE.VIVO:
                return 'VIVO小游戏';
            case PLATFORM_CODE.WX:
                return '微信小游戏';
            case PLATFORM_CODE.H5_4399:
                return '4399小游戏';
            case PLATFORM_CODE.GAME_BOX_4399:
                return '4399游戏盒子';
            default:
                return '未知平台';
        }
    }

    //
    showOssPathMiniGameJumpIcon(iconId: string, sprite: cc.Sprite) {
        let url = this.getPlatformJumpUrl(iconId);
        O1HD.getServices().miniGameSrv.getAppApiInstance().drawUrlImage(url, spf => {
            sprite.spriteFrame = spf;
        });
    }

    private getPlatformJumpUrl(iconId: string) {
        let path = this.m_htpUrl.replace('.json', '/');
        path = path.replace('#', this.m_platform);
        path += `${iconId}.jpg`;
        if (gameConfig.IS_OPEN_CLOG) {
            console.log('跳转小游戏图标 最终路径', path);
        }
        return path;
    }

    async loadService(): Promise<void> {
        await super.loadService();
        this.onSetPlatform();
        return this.loadConfig();
    }

    private getPlatformUrl() {
        let fileName = this.m_platform + '-' + this.m_ossVersion;

        let timer = '';//`?time=${Math.floor(Date.now() / (1000 * 60 * 5))}`;
        //
        if (!miniGameService.getMiniGameAppStatic().isProduction()) {
            const cdnTestTime = this.m_htpUrl.replace(/#/g, fileName + '-test') + timer;
            return cdnTestTime;
        }
        const cdnTime = this.m_htpUrl.replace(/#/g, fileName) + timer;
        return cdnTime;
    }

    private onSetPlatform() {
        if (window.hasOwnProperty('gamebox')) {
            if (gameConfig.IS_OPEN_CLOG) {
                console.warn('4399游戏盒子 first');
                console.log('4399游戏盒子 first');
            }
            this.m_platform = PLATFORM_CODE.GAME_BOX_4399;
            return;
        }
        switch (cc.sys.platform) {
            case cc.sys.WECHAT_GAME:
            case cc.sys.WECHAT_GAME_SUB: {
                this.m_platform = PLATFORM_CODE.KS;
                break;
            }
            case cc.sys.BYTEDANCE_GAME:
            case cc.sys.BYTEDANCE_GAME_SUB: {
                this.m_platform = PLATFORM_CODE.TT;
                break;
            }
            case cc.sys.HUAWEI_GAME: {
                console.log('华为快游戏');
                this.m_platform = PLATFORM_CODE.HU_WEI;
                break;
            }
            case cc.sys.VIVO_GAME: {
                console.log('vivo快游戏');
                this.m_platform = PLATFORM_CODE.VIVO;
                break;
            }
            case cc.sys.OPPO_GAME: {
                console.log('oppo快游戏');
                this.m_platform = PLATFORM_CODE.OPPO;
                break;
            }
            default: {
                if (cc.sys.isNative) {
                    if (cc.sys.os == cc.sys.OS_ANDROID) {
                        console.log('Android 游戏');
                        this.m_platform = PLATFORM_CODE.ANDROID;
                    } else if (cc.sys.os == cc.sys.OS_IOS) {
                        console.log('iOS 游戏');
                        this.m_platform = PLATFORM_CODE.IOS;
                    } else {
                        this.m_platform = PLATFORM_CODE.TT;
                    }
                } else {
                    if (cc.sys.platform == 3 || cc.sys.platform == 4) {
                        console.log('快手小游戏');
                        this.m_platform = PLATFORM_CODE.KS;
                    } else {
                        if (window.hasOwnProperty('h5api')) {
                            console.log('4399小游戏');
                            this.m_platform = PLATFORM_CODE.H5_4399;
                        } else if (window.hasOwnProperty('gamebox')) {
                            console.log('4399游戏盒子');
                            this.m_platform = PLATFORM_CODE.GAME_BOX_4399;
                        } else {
                            console.log('h5小游戏');
                            this.m_platform = PLATFORM_CODE.H5;
                        }
                    }
                }
                break;
            }
        }
        // 测试
        // this.m_platform = 'app/Android';
    }

    private async loadConfig(): Promise<void> {
        //
        return new Promise<void>(resolve => {
            //
            const url = this.getPlatformUrl();
            O1HD.emit('loading-title', '正在连接服务器……');

            if (gameConfig.IS_OPEN_CLOG) {
                console.log('oss 加载URL', this.getPlatformUrl());
            }
            // if (services().ossSrv.getPlatform() == PLATFORM_CODE.H5_4399) {
            //     return Promise.resolve();
            // }
            cc.assetManager.loadRemote(url, (err, textAsset: cc.JsonAsset) => {
                if (err) {
                    O1HD.emit('loading-title', '服务器连接失败，请检查网络设置后重试！');
                    // modules().uiControlModule.showDialogBox('连接失败', '跟服务器连接失败，请检查网络设置');
                    // console.error(DEEP_NEXT_SPLIT, '#20错误的加载', err);
                    // setTimeout(() => {
                    //     cc.game.restart();
                    // }, 1500);
                    return;
                }
                const json = textAsset.json;
                if (gameConfig.IS_OPEN_CLOG) {
                    console.log('oss 加载到的数值', JSON.stringify(json));
                }

                //修改配置
                let keys = Object.keys(gameConfig);
                for (let key in json) {
                    if (keys.includes(key)) {
                        // console.log(DEEP_NEXT_SPLIT, 'oss 重写', key, json[key]);
                        gameConfig[key] = json[key];
                    }
                }

                resolve();
            });
        });
    }
}



































